import { Component } from 'react';
import './styles.css';

import { IoLogoWhatsapp, IoMailOutline } from 'react-icons/io5';

class HeaderMeuSite extends Component {
  render() {
    const { imagem, nomeEscritorio, especialidades, email, contato } =
      this.props;

    return (
      <header className="header-meu-site">
        {imagem}
        <div className="about">
          <div className="sobre">
            <p>Escritório: {nomeEscritorio}</p>
            <div className="separador" />
            <div className="especialidades divisor-simples">
              <p id="especialidades-text">Especialidades:</p>
              {especialidades?.map((v) => (
                <span key={`${v}`}>{v}</span>
              ))}
            </div>
          </div>
          <div className="contato divisor-simples">
            <IoMailOutline />
            <p>Email: {email}</p>
            <div className="separador" />
            <IoLogoWhatsapp />
            <p>Contato: {contato}</p>
          </div>
        </div>
      </header>
    );
  }
}

export default HeaderMeuSite;
